import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import * as ReactNative from "react-native-web/dist/index";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import dateutils from "../dateutils";
import { xdateToData, parseDate } from "../interface";
import styleConstructor from "./style";
import Day from "./day/basic";
import UnitDay from "./day/period";
import MultiDotDay from "./day/multi-dot";
import MultiPeriodDay from "./day/multi-period";
import SingleDay from "./day/custom";
import CalendarHeader from "./header";
import shouldComponentUpdate from "./updater";
import GestureRecognizer, { swipeDirections } from 'react-native-swipe-gestures';
import { SELECT_DATE_SLOT } from "../testIDs";
import { jsx as ___EmotionJSX } from "@emotion/core";
var View = ReactNative.View,
    ViewPropTypes = ReactNative.ViewPropTypes;
var viewPropTypes = ViewPropTypes || View.propTypes;
var EmptyArray = [];

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar(props) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addMonth", function (count) {
      _this.updateMonth(_this.state.currentMonth.clone().addMonths(count, true));
    });

    _defineProperty(_assertThisInitialized(_this), "isDateNotInTheRange", function (minDate, maxDate, date) {
      return minDate && !dateutils.isGTE(date, minDate) || maxDate && !dateutils.isLTE(date, maxDate);
    });

    _defineProperty(_assertThisInitialized(_this), "getAccessibilityLabel", function (state, day) {
      var today = XDate.locales[XDate.defaultLocale].today;
      var formatAccessibilityLabel = XDate.locales[XDate.defaultLocale].formatAccessibilityLabel;
      var isToday = state === 'today';

      var markingLabel = _this.getDateMarking(day);

      if (formatAccessibilityLabel) {
        return (isToday ? today : '') + " " + day.toString(formatAccessibilityLabel) + " " + markingLabel;
      }

      return (isToday ? 'today' : '') + " " + day.toString('dddd d MMMM yyyy') + " " + markingLabel;
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipe", function (gestureName) {
      var enableSwipeMonths = _this.props.enableSwipeMonths;

      if (!enableSwipeMonths) {
        return;
      }

      var SWIPE_UP = swipeDirections.SWIPE_UP,
          SWIPE_DOWN = swipeDirections.SWIPE_DOWN,
          SWIPE_LEFT = swipeDirections.SWIPE_LEFT,
          SWIPE_RIGHT = swipeDirections.SWIPE_RIGHT;

      switch (gestureName) {
        case SWIPE_UP:
        case SWIPE_DOWN:
          break;

        case SWIPE_LEFT:
          _this.onSwipeLeft();

          break;

        case SWIPE_RIGHT:
          _this.onSwipeRight();

          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeLeft", function () {
      _this.header.onPressRight();
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeRight", function () {
      _this.header.onPressLeft();
    });

    _this.style = styleConstructor(_this.props.theme);
    _this.state = {
      currentMonth: props.current ? parseDate(props.current) : XDate()
    };
    _this.updateMonth = _this.updateMonth.bind(_assertThisInitialized(_this));
    _this.pressDay = _this.pressDay.bind(_assertThisInitialized(_this));
    _this.longPressDay = _this.longPressDay.bind(_assertThisInitialized(_this));
    _this.shouldComponentUpdate = shouldComponentUpdate;
    return _this;
  }

  _createClass(Calendar, [{
    key: "updateMonth",
    value: function updateMonth(day, doNotTriggerListeners) {
      var _this2 = this;

      if (day.toString('yyyy MM') === this.state.currentMonth.toString('yyyy MM')) {
        return;
      }

      this.setState({
        currentMonth: day.clone()
      }, function () {
        if (!doNotTriggerListeners) {
          var currMont = _this2.state.currentMonth.clone();

          if (_this2.props.onMonthChange) {
            _this2.props.onMonthChange(xdateToData(currMont));
          }

          if (_this2.props.onVisibleMonthsChange) {
            _this2.props.onVisibleMonthsChange([xdateToData(currMont)]);
          }
        }
      });
    }
  }, {
    key: "_handleDayInteraction",
    value: function _handleDayInteraction(date, interaction) {
      var day = parseDate(date);
      var minDate = parseDate(this.props.minDate);
      var maxDate = parseDate(this.props.maxDate);

      if (!(minDate && !dateutils.isGTE(day, minDate)) && !(maxDate && !dateutils.isLTE(day, maxDate))) {
        var shouldUpdateMonth = this.props.disableMonthChange === undefined || !this.props.disableMonthChange;

        if (shouldUpdateMonth) {
          this.updateMonth(day);
        }

        if (interaction) {
          interaction(xdateToData(day));
        }
      }
    }
  }, {
    key: "pressDay",
    value: function pressDay(date) {
      this._handleDayInteraction(date, this.props.onDayPress);
    }
  }, {
    key: "longPressDay",
    value: function longPressDay(date) {
      this._handleDayInteraction(date, this.props.onDayLongPress);
    }
  }, {
    key: "renderDay",
    value: function renderDay(day, id) {
      var minDate = parseDate(this.props.minDate);
      var maxDate = parseDate(this.props.maxDate);
      var state = '';

      if (this.props.disabledByDefault) {
        state = 'disabled';
      } else if (this.isDateNotInTheRange(minDate, maxDate, day)) {
        state = 'disabled';
      } else if (!dateutils.sameMonth(day, this.state.currentMonth)) {
        state = 'disabled';
      } else if (dateutils.sameDate(day, XDate())) {
        state = 'today';
      }

      if (!dateutils.sameMonth(day, this.state.currentMonth) && this.props.hideExtraDays) {
        return ___EmotionJSX(View, {
          key: id,
          style: {
            flex: 1
          }
        });
      }

      var DayComp = this.getDayComponent();
      var date = day.getDate();
      var dateAsObject = xdateToData(day);
      var accessibilityLabel = this.getAccessibilityLabel(state, day);
      return ___EmotionJSX(View, {
        style: {
          flex: 1,
          alignItems: 'center'
        },
        key: id
      }, ___EmotionJSX(DayComp, {
        testID: SELECT_DATE_SLOT + "-" + dateAsObject.dateString,
        state: state,
        theme: this.props.theme,
        onPress: this.pressDay,
        onLongPress: this.longPressDay,
        date: dateAsObject,
        marking: this.getDateMarking(day),
        accessibilityLabel: accessibilityLabel,
        disableAllTouchEventsForDisabledDays: this.props.disableAllTouchEventsForDisabledDays
      }, date));
    }
  }, {
    key: "getMarkingLabel",
    value: function getMarkingLabel(day) {
      var label = '';
      var marking = this.getDateMarking(day);

      if (marking.accessibilityLabel) {
        return marking.accessibilityLabel;
      }

      if (marking.selected) {
        label += 'selected ';

        if (!marking.marked) {
          label += 'You have no entries for this day ';
        }
      }

      if (marking.marked) {
        label += 'You have entries for this day ';
      }

      if (marking.startingDay) {
        label += 'period start ';
      }

      if (marking.endingDay) {
        label += 'period end ';
      }

      if (marking.disabled || marking.disableTouchEvent) {
        label += 'disabled ';
      }

      return label;
    }
  }, {
    key: "getDayComponent",
    value: function getDayComponent() {
      if (this.props.dayComponent) {
        return this.props.dayComponent;
      }

      switch (this.props.markingType) {
        case 'period':
          return UnitDay;

        case 'multi-dot':
          return MultiDotDay;

        case 'multi-period':
          return MultiPeriodDay;

        case 'custom':
          return SingleDay;

        default:
          return Day;
      }
    }
  }, {
    key: "getDateMarking",
    value: function getDateMarking(day) {
      if (!this.props.markedDates) {
        return false;
      }

      var dates = this.props.markedDates[day.toString('yyyy-MM-dd')] || EmptyArray;

      if (dates.length || dates) {
        return dates;
      } else {
        return false;
      }
    }
  }, {
    key: "renderWeekNumber",
    value: function renderWeekNumber(weekNumber) {
      return ___EmotionJSX(View, {
        style: {
          flex: 1,
          alignItems: 'center'
        },
        key: "week-container-" + weekNumber
      }, ___EmotionJSX(Day, {
        key: "week-" + weekNumber,
        theme: this.props.theme,
        marking: {
          disableTouchEvent: true
        },
        state: "disabled"
      }, weekNumber));
    }
  }, {
    key: "renderWeek",
    value: function renderWeek(days, id) {
      var _this3 = this;

      var week = [];
      days.forEach(function (day, id2) {
        week.push(_this3.renderDay(day, id2));
      }, this);

      if (this.props.showWeekNumbers) {
        week.unshift(this.renderWeekNumber(days[days.length - 1].getWeek()));
      }

      return ___EmotionJSX(View, {
        style: this.style.week,
        key: id
      }, week);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var currentMonth = this.state.currentMonth;
      var _this$props = this.props,
          firstDay = _this$props.firstDay,
          showSixWeeks = _this$props.showSixWeeks,
          hideExtraDays = _this$props.hideExtraDays;
      var shouldShowSixWeeks = showSixWeeks && !hideExtraDays;
      var days = dateutils.page(currentMonth, firstDay, shouldShowSixWeeks);
      var weeks = [];

      while (days.length) {
        weeks.push(this.renderWeek(days.splice(0, 7), weeks.length));
      }

      var indicator;
      var current = parseDate(this.props.current);

      if (current) {
        var lastMonthOfDay = current.clone().addMonths(1, true).setDate(1).addDays(-1).toString('yyyy-MM-dd');

        if (this.props.displayLoadingIndicator && !(this.props.markedDates && this.props.markedDates[lastMonthOfDay])) {
          indicator = true;
        }
      }

      return ___EmotionJSX(GestureRecognizer, {
        onSwipe: function onSwipe(direction, state) {
          return _this4.onSwipe(direction, state);
        }
      }, ___EmotionJSX(View, {
        style: [this.style.container, this.props.style],
        accessibilityElementsHidden: this.props.accessibilityElementsHidden,
        importantForAccessibility: this.props.importantForAccessibility
      }, ___EmotionJSX(CalendarHeader, {
        testID: this.props.testID,
        ref: function ref(c) {
          return _this4.header = c;
        },
        style: this.props.headerStyle,
        theme: this.props.theme,
        hideArrows: this.props.hideArrows,
        month: this.state.currentMonth,
        addMonth: this.addMonth,
        showIndicator: indicator,
        firstDay: this.props.firstDay,
        showSixWeeks: this.props.showSixWeeks,
        renderArrow: this.props.renderArrow,
        monthFormat: this.props.monthFormat,
        hideDayNames: this.props.hideDayNames,
        weekNumbers: this.props.showWeekNumbers,
        onPressArrowLeft: this.props.onPressArrowLeft,
        onPressArrowRight: this.props.onPressArrowRight,
        webAriaLevel: this.props.webAriaLevel,
        disableArrowLeft: this.props.disableArrowLeft,
        disableArrowRight: this.props.disableArrowRight,
        disabledDaysIndexes: this.props.disabledDaysIndexes,
        renderHeader: this.props.renderHeader
      }), ___EmotionJSX(View, {
        style: this.style.monthView
      }, weeks)));
    }
  }]);

  return Calendar;
}(Component);

_defineProperty(Calendar, "displayName", 'Calendar');

_defineProperty(Calendar, "propTypes", {
  theme: PropTypes.object,
  markedDates: PropTypes.object,
  style: viewPropTypes.style,
  current: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  firstDay: PropTypes.number,
  markingType: PropTypes.string,
  hideArrows: PropTypes.bool,
  displayLoadingIndicator: PropTypes.bool,
  hideExtraDays: PropTypes.bool,
  showSixWeeks: PropTypes.bool,
  onDayPress: PropTypes.func,
  onDayLongPress: PropTypes.func,
  onMonthChange: PropTypes.func,
  onVisibleMonthsChange: PropTypes.func,
  renderArrow: PropTypes.func,
  dayComponent: PropTypes.any,
  monthFormat: PropTypes.string,
  disableMonthChange: PropTypes.bool,
  hideDayNames: PropTypes.bool,
  disabledByDefault: PropTypes.bool,
  showWeekNumbers: PropTypes.bool,
  onPressArrowLeft: PropTypes.func,
  onPressArrowRight: PropTypes.func,
  disableArrowLeft: PropTypes.bool,
  disableArrowRight: PropTypes.bool,
  headerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  webAriaLevel: PropTypes.number,
  disabledDaysIndexes: PropTypes.arrayOf(PropTypes.number),
  disableAllTouchEventsForDisabledDays: PropTypes.bool,
  renderHeader: PropTypes.any,
  enableSwipeMonths: PropTypes.bool
});

_defineProperty(Calendar, "defaultProps", {
  enableSwipeMonths: false
});

export default Calendar;

if (typeof Calendar !== 'undefined' && Calendar && Calendar === Object(Calendar) && Object.isExtensible(Calendar) && !Calendar.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Calendar, '__filemeta', {
    configurable: true,
    value: {
      name: "Calendar",
      filename: "node_modules/react-native-calendars/src/calendar/index.js"
    }
  });
}